import { render, staticRenderFns } from "./VesselsTable.vue?vue&type=template&id=16027699&"
import script from "./VesselsTable.vue?vue&type=script&lang=js&"
export * from "./VesselsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports